import { DocumentsQuery } from 'generated/graphql';

type Document = NonNullable<DocumentsQuery['documents']['edges'][number]['node']>;

export const groupDocuments = (documents: Document[]) => {
  const accumulator: Record<string, Document[]> = {};

  return documents.reduce((acc, cur) => {
    const existing = acc[cur.folderName as keyof Record<string, Document[]>] || [];
    return { ...acc, [cur.folderName]: [...existing, cur] };
  }, accumulator);
};
